import {createBarbaPage} from '../baseBarbaPage';
import { initLoginForm, resetFormVisibility } from "../../modules/form-login/form-login";
import { initRequestQuoteForm } from "../../modules/form-request-quote/form-request-quote";
import { getCheckoutUri } from "../../src/js/serverInfo";


export default createBarbaPage({
    namespace: 'cart',
    onEnter: function() {
        // The new Container is ready and attached to the DOM.
        initLoginForm();
        initRequestQuoteForm();
        $('.checkout-button').click(ev => {
            resetFormVisibility();
        });

        let checkoutUri = getCheckoutUri();

        $('.stripe-btn').click((ev) => {
            $('.checkout-redirect').val(checkoutUri);
            $('.form-login-guest-link').attr("href", checkoutUri);
        });

        $('.cart-purchase-order-btn').click((ev) => {
            const purchaseOrderUri = `${checkoutUri}?payment=cod`;
            $('.checkout-redirect').val(purchaseOrderUri);
            $('.form-login-guest-link').attr("href", purchaseOrderUri);
        });

        // Enable button on update qty
        let tempBtn = $("a.checkout-button.wc-forward").html();
        jQuery(document.body).on('updated_wc_div', { tempBtn }, enableBuyBtn);
    },
    onEnterCompleted: function() {
        // The Transition has just finished.
    },
    onLeave: function() {
        // A new Transition toward a new page has just started.
        jQuery(document.body).off('updated_wc_div', enableBuyBtn);
    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.
    }
});

function enableBuyBtn(ev) {
    $("a.checkout-button.wc-forward").removeClass('disabled').html(ev.data.tempBtn);
}

// !!!! Don't forget to init the view in page-transitions/barba-init.js !!!!!
